<template>
  <div>
    <div class="top-content col-xs-12 consumer-duty">
      <div class="summary-top-bar">
        <div class="right">
          <form @submit.prevent="onSearch">
            <input
                type="text"
                name="search"
                placeholder="Search"
                v-model="searchQuery"
            />
            <button type="submit" class="btn btn-secondary btn-search">Search</button>
          </form>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
    <table class="table table-responsive">
      <thead>
      <tr>
        <td>Client ID</td>
        <td>Type</td>
        <td>Client/Business Name</td>
        <td>Missing Data</td>
        <td>Updated</td>
        <td class="text-right">Action</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :id="items[index].client_id">
        <td>{{item.client_id}}</td>
        <td>{{item.type}}</td>
        <td v-if="item.type === 'Person'">{{item.first_name + ' ' + item.last_name}}</td>
        <td v-else>{{item.business_name}}</td>
        <td>
          <ul>
            <li v-for="(colIndex, colName) in item.missing_data_columns">
              <button type="button" @click="editDataMissed(colIndex, colName, item)" style="all: unset;cursor: pointer;display: inline;color: inherit;font: inherit;">
                {{colName}}
              </button>
            </li>
            <div style="clear:both"></div>
          </ul>
        </td>
        <td>{{item.updated_at}}</td>
        <td class="text-right">
          <button type="button" class="btn btn-success" @click="syncDataClient(item.client_id); ">
            <i class="fa fa-refresh" :id="'button_icon_' + item.client_id"></i>
          </button>
          <button type="button" class="btn btn-success" @click="editDataClient(item); ">
            <i class="fa fa-edit" :id="'button_edit_icon_' + item.client_id"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <pagination :response="meta" @setPage="getMissingData"></pagination>

    <vue-final-modal
        modal-id="update-missing-data"
        class="modal--container modal-shadow"
        content-class="modal--content"
        :content-style="{height: 'auto'}"
        height="auto"
        @closed="resetFormMissingData">
      <div class="update-missing-data-modal-content">

        <div class="card-title">Edit missed data field: {{formMissingData.field_name}}</div>
        <div class="card-subtitle">Client name: {{formMissingData.client_name}}</div>

        <!--String-->
        <input v-if="['first_name', 'last_name', 'title', 'nationality', 'ni_number', 'marital_status', 'business_type', 'business_name', 'company_registration_number', 'vat_number'].includes(formMissingData.field_name)"
               type="text"
               class="form-control"
               :name=formMissingData.field_name
               id="missed_data_field"
               :placeholder=formMissingData.field_name
               v-model="formMissingData.field_value"
        />
        <!--End String-->

        <!--Bool-->
        <div v-if="['will_up_to_date', 'uk_domicile', 'uk_resident', 'good_health', 'vat_registered'].includes(formMissingData.field_name)">
          <label>
            <input type="radio" :name="formMissingData.field_name" value="true" v-model="formMissingData.field_value" />
            True
          </label>
          <label>
            <input type="radio" :name="formMissingData.field_name" value="false" v-model="formMissingData.field_value" />
            False
          </label>
        </div>
        <!--End Bool-->

        <!--select-->
        <select
            v-if="formMissingData.field_name === 'gender'"
            class="form-control"
            :name="formMissingData.field_name"
            v-model="formMissingData.field_value"
        >
          <option value="null" disabled selected hidden>
            Select option
          </option>
          <option value="Unspecified">Unspecified</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
        <select
            v-else-if="formMissingData.field_name === 'smoker'"
            class="form-control"
            :name="formMissingData.field_name"
            v-model="formMissingData.field_value"
        >
          <option value="null" disabled selected hidden>
            Select option
          </option>
          <option value="Unknown">Unknown</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <!--End Select-->

        <!-- Date -->
        <input
            v-else-if="formMissingData.field_name === 'dob'"
            type="date"
            class="form-control"
            :name="formMissingData.field_name"
            id="missed_data_field"
            v-model="formMissingData.field_value"
        />

        <!-- Date-time -->
        <input
            v-else-if="formMissingData.field_name === 'incorporation_date'"
            type="datetime-local"
            class="form-control"
            :name="formMissingData.field_name"
            id="missed_data_field"
            v-model="formMissingData.field_value"
        />

        <br/>

        <p v-if="['address1', 'address2', 'address3', 'address4', 'address5', 'address6', 'post_code'].includes(formMissingData.field_name)">This option cannot be changed from this form yet</p>

        <button v-else class="answer-button" v-on:click="sendNewData('update-missing-data')">
          <span class="update-answer">UPDATE DATA</span>
        </button>
      </div>
    </vue-final-modal>


    <vue-final-modal
        modal-id="update-client-data"
        class="modal--container modal-shadow"
        content-class="modal--content"
        :content-style="{
          width: '80vw',
          maxWidth: '1200px',
          maxHeight: '80vh',
          overflowY: 'auto',
          height: 'auto',
          padding: '20px',
        }"
        height="auto"
        @closed="resetFormClientData">
      <div class="update-client-data-modal-content">
        <intelliflo-office-client-form
            :client_id="currentClientId"
            :client_name="currentClientName"
            @data-updated="sentNewClientData"/>
      </div>
    </vue-final-modal>

  </div>
</template>

<script>
import { VueFinalModal, ModalsContainer } from 'vue-final-modal'
import IntellifloOfficeClientForm from "./IntellifloOfficeClientForm.vue";

export default {
  name: "IntellifloOfficeMissingDataTable",
  components: {
    IntellifloOfficeClientForm,
    VueFinalModal,
    ModalsContainer,
  },
  data() {
    return {
      items: {
        missing_data_columns: [],
      },
      meta: {},
      page: null,
      thisPage: null,
      searchQuery: '',
      currentClientId: null,
      currentClientName: null,
      formMissingData: {
        field_name: null,
        field_value: null,
        client_id: null,
        client_name: null,
      },
    }
  },
  methods: {
    onSearch() {
      this.getMissingData(1, this.searchQuery);
    },
    getMissingData(page = 1, search = '') {
      this.thisPage = page;
      axios.get(`/io/missing-data?page=${page}`, {
        params: { page, search },
      }).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    syncDataClient(clientId) {
      this.inProcess(clientId, true)
      axios.get(`/io/syncdata-client/${clientId}`).then((res) => {
        this.markUpdateStatus(clientId, res.data.update_status);
        this.inProcess(clientId, false);
        setTimeout(() => {
          const row = document.getElementById(clientId);
          row.classList.remove(res.data.update_status);
          this.getMissingData(this.thisPage);
        }, 2000);
      }).catch((error) => {
        console.log('error', error)
        this.inProcess(clientId, false)
      })
    },
    editDataMissed(colIndex, colName, item) {
      this.formMissingData.client_id = item.client_id;
      this.formMissingData.field_name = colName;
      this.formMissingData.client_name = item.first_name + ' ' + item.last_name;
      this.$vfm.open("update-missing-data");
    },
    editDataClient(item) {
      this.currentClientId = item.client_id;
      this.currentClientName = item.first_name + ' ' + item.last_name;
      this.$vfm.open("update-client-data");
    },
    resetFormMissingData() {
      this.formMissingData = {
        client_id: null,
        field_name: '',
        client_name: '',
        field_value: ''
      };
    },
    resetFormClientData() {
      this.currentClientId = null;
      this.currentClientName = null;
    },
    sendNewData(modalName) {
      this.$vfm.close(modalName);

      axios.post(`/io/missing-data/update-field`, this.formMissingData)
          .then((res) => {
            console.log(res.data);
            this.syncDataClient(res.data.client_id);
          })
          .catch((error) => {
            console.log('error', error)
          })

      this.resetFormMissingData();
    },
    sentNewClientData(data) {
      this.$vfm.close('update-client-data');
      this.syncDataClient(data.client_id);
      this.resetFormClientData()
    },
    inProcess(clientId, process) {
      const icon = document.getElementById('button_icon_' + clientId);
      if (process) {
        icon.classList.add("fa-spin");
      } else {
        icon.classList.remove("fa-spin");
      }
    },
    markUpdateStatus(clientId, className) {
      const row = document.getElementById(clientId);
      row.classList.add(className);
    }
  },
  created() {
    this.getMissingData();
  }
}
</script>

<style scoped>
:not(.input-group-btn) > .btn:not(.btn-search) {
  padding: 8px 0;
  border-radius: 0;
  background-color: #73C2AF;
}
.btn-search {
  margin-left: 10px;
}
</style>